"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.simulateWithdraw = exports.estimateSlippage = void 0;
const ethers_1 = require("ethers");
const constants_1 = __importDefault(require("../constants"));
const bignumber_1 = require("../utils/bignumber");
const feeManager_1 = require("./feeManager");
function estimateSlippage(chainID, stableSymbol, collateralSymbol, collatRatio, callRatioParams, _xSlippage = [ethers_1.BigNumber.from(0)], _ySlippage = [ethers_1.BigNumber.from(0)], _xSlippageFee = [ethers_1.BigNumber.from(0)], _ySlippageFee = [ethers_1.BigNumber.from(0)]) {
    if (!collatRatio && callRatioParams !== undefined)
        collatRatio = (0, feeManager_1.computeCollateralRatio)(callRatioParams.agTokensMinted, callRatioParams.amountInProtocol, callRatioParams.inDecimals, callRatioParams.rates, callRatioParams.base);
    collatRatio = ethers_1.BigNumber.from(collatRatio);
    const xSlippage_ = _xSlippage.map((v) => ethers_1.BigNumber.from(v));
    const ySlippage_ = _ySlippage.map((v) => ethers_1.BigNumber.from(v));
    const xSlippageFee_ = _xSlippageFee.map((v) => ethers_1.BigNumber.from(v));
    const ySlippageFee_ = _ySlippageFee.map((v) => ethers_1.BigNumber.from(v));
    const slippage = (0, bignumber_1.piecewiseFunction)(collatRatio, xSlippage_, ySlippage_);
    const slippageFee = (0, bignumber_1.piecewiseFunction)(collatRatio, xSlippageFee_, ySlippageFee_);
    return { slippage, slippageFee };
}
exports.estimateSlippage = estimateSlippage;
function simulateWithdraw(chainID, stableSymbol, collateralSymbol, sanTokensAmount, sanRate, collatRatio, callRatioParams) {
    const cons = (0, constants_1.default)(chainID);
    const { slippage } = estimateSlippage(chainID, stableSymbol, collateralSymbol, collatRatio, callRatioParams);
    const withdrawAmount = cons.BASE_PARAMS.sub(slippage).mul(sanTokensAmount).mul(sanRate).div(cons.BASE_TOKENS.mul(cons.BASE_PARAMS));
    return withdrawAmount;
}
exports.simulateWithdraw = simulateWithdraw;
//# sourceMappingURL=slp.js.map